import { toast } from "sonner"
import DOMPurify from "dompurify"
import React, { useState } from "react"
import { navigate } from "gatsby"
import { useIntl } from "react-intl"
import { WingsHeading, WingsDetailText } from "@wingspans-ui"
import "./toasts.css"

const sendUserNotificationToast = (notification) => {
  // class we can assign to toast to prevent duplicate toasts from being displayed off the same notification
  const classIdentifier = `toast-${notification.notificationId}`
  let isWindowWide = false

  if (typeof window !== "undefined") {
    const element = document.querySelector(`.${classIdentifier}`)
    isWindowWide = window.innerWidth > 1100
    if (element) return
  }

  toast.dismiss(classIdentifier)

  toast(<UserNotification notification={notification} handleDelete={() => toast.dismiss(classIdentifier)} />, {
    position: isWindowWide ? "top-right" : "bottom-right",
    closeButton: true,
    duration: 12000,
    id: notification.notificationId,
    className: classIdentifier,
    style: {
      marginTop: "1rem",
      padding: "0",
    },
  })
}

const UserNotification = ({ notification, handleDelete }) => {
  // destriucture notification object found in firebase userNotifications collection
  const { message, messageEs, type, publicationDate, notificationId, isRead, pageLink, heading, headingEs } = notification
  const { locale } = useIntl()

  const [isHovered, setIsHovered] = useState(false)

  const isNavigational = !!pageLink

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  function CleanHTML({ dirtyHTML }) {
    if (!dirtyHTML) return ""

    // Sanitize the text
    const sanitizedText = DOMPurify.sanitize(dirtyHTML)

    // OLD CODE for bolding numbers, keeping in case we need to revert

    // // Define a regular expression to match numbers
    // const regex = /(\d+)/g

    // // Split the text into parts based on the regex
    // const parts = sanitizedText.split(regex)

    // // Map through the parts, wrapping numbers in <strong> tags
    // const formattedText = parts.map((part, index) => {
    //   if (part.match(regex)) {
    //     return <span key={index}>{part}</span>
    //   } else {
    //     return part
    //   }
    // })

    return <div dangerouslySetInnerHTML={{ __html: sanitizedText }} />
  }

  const handleNavigation = (notificationId) => {
    if (isNavigational) {
      navigate(`${pageLink}`)
      toast.dismiss(notificationId)
    }
  }

  return (
    <>
      <div
        className={`notifications-toast-item ${type} ${isNavigational ? "link" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        role={`${isNavigational ? "link" : ""}`}
        onClick={() => handleNavigation(notificationId)}
      >
        <div className="notifications-toast-item-header">
          <WingsHeading level={6} as="span" className={`notifications-toast-item-title ${type}`}>
            {locale === "es-ES" ? headingEs : heading}
            <svg width="100%" height="8" viewBox="0 0 300 8" preserveAspectRatio="none" style={{ position: "absolute", top: "100%", left: 0, marginTop: "-5px", display: "block" }}>
              <path d="M 3 3 Q 150 1 297 4" stroke="#C837D3" strokeWidth="2.5" fill="none" strokeLinecap="round" />
            </svg>
          </WingsHeading>
        </div>
        <WingsDetailText as="div" className="notifications-toast-item-body">
          <CleanHTML dirtyHTML={locale === "es-ES" ? messageEs : message} />
        </WingsDetailText>
      </div>
    </>
  )
}

export default sendUserNotificationToast
